import Firestore from '../initFirebase'
import { debounce } from 'lodash'
import { globalOnDemandVars } from '../../helper/context'
import {
  notSavedInSharing,
  handleErrorInCatch,
  savingEnd,
  savingStart,
  notSavedInAnonymous
} from '../../helper/functions'

//
export const mutateAddOnAsync = async (id, inputObj) => {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (globalOnDemandVars.addOnsReady()) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'appsync update / addOn',
        value: {
          id,
          inputObj
        }
      // , important: true
      })
    }
    try {
      savingStart()
      await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('AddOnConfig').doc(id).update(inputObj)
      savingEnd()
    } catch (e) {
      handleErrorInCatch(e, 'addons')
    }
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('appsync update / addOn 끝')
    }
  }
}

export const mutateAddOnAsyncDebounced = debounce(mutateAddOnAsync, (500), {
  leading: false, trailing: true
})
